<template>
  <div id="gb-wrapper" v-if="isEnable">
    <template v-if="isMobileDevice">

      <div class="gb-widget-toggle" @click="toggle">
        <img src="./chat.png" alt="Chat icon">
      </div>

      <transition name="fade" >
        <div class="gb-zb-button-tooltip"
             v-on:click="toggle" v-if="isTooltipShown === true">
          Hello ! Comment puis-je vous aider ?
        </div>
      </transition>

      <transition name="gb-fade" >
        <div class="gb-widget" v-show="isVisible">

          <div class="gb-widget__close" @click="toggle(false)">X</div>

          <h5>Une question ?</h5>

          <ul class="gb-channels">
            <li class="gb-channel">
              <div>
                <a class="gb-channel whatsapp" href="https://api.whatsapp.com/send?phone=33172772633&text=demarrez%20votre%20conversation">
                </a>
              </div>
              <a class="gb-channel " href="https://api.whatsapp.com/send?phone=33172772633&text=demarrez%20votre%20conversation">
                Contactez-nous sur WhatsApp
                </a>
            </li>
            <li class="gb-channel" @click.capture="triggerABC" v-if="isABCSupported">
              <div class="apple-business-chat-message-container"
               data-apple-business-id="4c15722a-9450-4f79-93c7-c1f303d64d26"
               data-apple-icon-background-color="#EFEFF4"
               data-apple-icon-color="#0078FF"
               data-apple-icon-title="Messages"
               data-apple-icon-scale="1.1"
               data-apple-business-body="demarrez votre conversation">
              </div>
              Contactez-nous sur Messages
            </li>
            <li class="gb-channel webchat">
              <div>
                {{ setupGreenbureauChat() }}
              </div>
              <span v-on:click="toggleChat($event)">
                Contactez-nous sur notre chat
              </span>
            </li>
          </ul>

        </div>
      </transition>
    </template>
    <div class="gb-channel webchat" v-if="!isMobileDevice">
      <div>{{ setupGreenbureauChat() }}</div>
    </div>
  </div>
</template>

<script>
import Widget from '@/components/Widget'

export default {
  name: 'Widget',
  extends: Widget,
  data () {
    return {
      disabled: false,
      hidden: true,
      isABCSupported: true,
      isTooltipShown: false
    }
  },
  computed: {
    isEnable () {
      return !this.disabled
    },
    isMobileDevice () {
      return this.$settings.ua.isMobile
    },
    isVisible () {
      return !this.hidden
    }
  },
  methods: {
    disable () {
      this.toggle(false)
      this.disabled = true
    },
    enable () {
      this.disabled = false
    },
    setupGreenbureauChat () {
      window.setTimeout(() => {
        const currNode = document.querySelector('.gb-channel.webchat div')
        const account = 'EDabJk6F9MGyeH7woQwnmB'
        const widget = '<script type="text/javascript"' +
            'data-gb-service="zenbot"' +
            'data-gb-account="' + account + '"' +
            'data-gb-keyword="site"' +
            'data-gb-host="https://proxy.greenbureau.com"' +
            'src="https://devcdn.greenbureau.com/js/gb.js" >' +
            // 'src="http://localhost:8081/js/zenbot.js" >' +
          // eslint-disable-next-line
          '<\/script>'
        const range = document.createRange()
        range.selectNode(currNode)
        const documentFragment = range.createContextualFragment(widget)
        currNode.appendChild(documentFragment)

        const el = document.querySelector('script[data-gb-account="' + account + '"]')

        window.setTimeout(() => {
          const gbWidget = window.GbWidget()
          gbWidget.zenbot(el)
        }, 250)
      }, 50)
    },
    toggle (forceVisibility) {
      if (this.isMobileDevice) {
        this.hidden = forceVisibility !== undefined ? !forceVisibility : !this.hidden
      } else {
        this.setupGreenbureauChat()
      }
    },
    toggleChat ($event) {
      $event.target.previousSibling.querySelector(
        'div.gb-zb-button').click()
    },
    triggerABC ($event) {
      if ($event.target.classList.contains('gb-channel')) {
        window.location.href = $event.target.querySelector('a').href
      }
    }
  },
  created () {
    // window.setTimeout(() => {
    //   this.isTooltipShown = true
    // }, 2000)
  },
  mounted () {
    // if (document.querySelector('.main-wrap') !== null) {
    //   document.querySelector('.main-wrap').style.position = 'static'
    // }
    // if (document.querySelector('#row-ligne-greenbureau') !== null) {
    //   document.querySelector('#row-ligne-greenbureau').style.position = 'static'
    // }

    // window.setTimeout(() => {
    //   const ABC = window.appleBusinessChat
    //   ABC.refresh()
    //   this.isABCSupported = ABC.isSupported()
    // }, 150)
  }
}

</script>

<style lang="scss" scoped>
  @import '@/components/widget.scss';
  @import url('https://fonts.googleapis.com/css?family=Noto+Sans&display=swap');

  $primary: #003c7e;
  $chat: #172b60;

  #gb-wrapper {
    z-index: 1999;
    display: flex;
    position: absolute;
    width: 100%;
    font-family: "Noto Sans";

    h5 {
      text-align: center;
      font-size: 20px;
      margin-bottom: 40px;
    }

    .gb-widget-toggle {
      width: 70px;
      height: 70px;
      border-radius: 50%;
      filter: drop-shadow(-1.67px 11.883px 8px rgba(1,18,75,0.3));
      background-color: $chat;
      position: fixed;
      right: 20px;
      bottom: 20px;
      transition: background-color .1s;

      &:hover {
        cursor: pointer;
        background-color: lighten($color: $chat, $amount: 15%);
      }

      img {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 50%;
      }
    }

    .gb-widget {
      color: $primary;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      background-color: rgba(255, 255, 255, .9);
      position: fixed;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      z-index: 9999;
    }

    .gb-widget__close {
      font-family: Arial;
      font-size: 22px;
      position: absolute;
      padding: 27px 12px;
      top: 0;
      right: 0;
      transition: color .1s;

      &:hover {
        cursor: pointer;
        color: lighten($color: $chat, $amount: 15%);
      }
    }

    .gb-fade-enter-active, .gb-fade-leave-active {
      transition: opacity .15s;
    }
    .gb-fade-enter, .gb-fade-leave-to {
      opacity: 0;
    }

    /*** CHANNELS ***/

    .gb-channels {
      list-style: none;
      padding: 0;
      margin: 0;
      max-width: 90%;

      & > li {
        position: relative;
        margin-bottom: 27px;
      }

      .gb-channel {
        display: flex;
        align-items: center;
        font-size: 14px;
        color: $primary;

        &:hover {
          text-decoration: underline;
          cursor: pointer;
        }

        & > *:first-child {
          margin-right: 13px;
          width: 47px;
          height: 47px;
          border-radius: 50%;
          text-align: center;
          // filter: drop-shadow(-0.835px 5.942px 6.5px rgba(1,18,75,0.17));
        }

        small {
          font-size:11.2px;
        }

      }

    }

    .apple-business-chat-message-container {
      background-image: linear-gradient(8deg, #61cd43 0%, #a3f781 100%);
      display: flex;
      align-items: center;
      justify-content: center;
      padding-left: 2px;
    }

    .whatsapp {
      background: transparent url("../../assets/whatsapp.png") no-repeat center right 5px;
      background-size: 35px auto;
      height: 100%;
      padding-right: 40px;
      width: 100%;
    }

    .webchat {
      background: url("../../assets/web.png") no-repeat center left 5px;
      background-size: 35px auto;
      padding-right: 40px;
      width: 100%;
    }

    .gb-chat > *:first-child {
      background-color: $chat;
      position: relative;
      flex-shrink: 0;

      img {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 50%;
        margin-left: 1px;
      }
    }

  }

  .gb-zb-button-tooltip {
    background: #FFF;
    border-radius: 10px;
    box-shadow: 0 10px 25px rgba(4,46,117,.2)!important;
    bottom: 100px;
    color: #455980;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    padding: 15px;
    position: fixed;
    right: 15px;
    width: 170px;
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .15s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
</style>
